import { randomBytes } from 'node:crypto';
import { chmodSync, linkSync, mkdirSync, unlinkSync, writeFileSync } from 'node:fs';
import { dirname } from 'node:path';

export interface BinaryResponse {
  data?: string;
  content?: string;
  size?: number;
  filename?: string;
  path?: string;
  contentType?: string;
  extension?: string;
  typeTag?: string;
}

export function writeBase64Output(
  response: BinaryResponse,
  outputPath: string,
): Record<string, unknown> {
  const encoded = response.data ?? response.content;
  if (typeof encoded !== 'string') throw new Error('Binary response contains no base64 payload');
  const bytes = Buffer.from(encoded, 'base64');
  if (response.size !== undefined && response.size !== bytes.length) {
    throw new Error(
      `Binary response size mismatch: expected ${response.size} bytes, received ${bytes.length}`,
    );
  }
  writeBytesOutput(bytes, outputPath);
  return {
    output: outputPath,
    size: bytes.length,
    filename: response.filename,
    sourcePath: response.path,
    contentType: response.contentType,
    extension: response.extension,
    typeTag: response.typeTag,
  };
}

export function writeBytesOutput(bytes: Uint8Array, outputPath: string): void {
  const directory = dirname(outputPath);
  mkdirSync(directory, { recursive: true, mode: 0o700 });
  const temporary = `${outputPath}.part-${process.pid}-${randomBytes(8).toString('hex')}`;
  try {
    writeFileSync(temporary, bytes, { mode: 0o600, flag: 'wx' });
    linkSync(temporary, outputPath);
    unlinkSync(temporary);
    chmodSync(outputPath, 0o600);
  } catch (error) {
    try {
      unlinkSync(temporary);
    } catch {
      // Nothing to clean up.
    }
    throw error;
  }
}
